import { render, staticRenderFns } from "./ChildAgent.vue?vue&type=template&id=fdbceace&scoped=true&"
import script from "./ChildAgent.vue?vue&type=script&lang=js&"
export * from "./ChildAgent.vue?vue&type=script&lang=js&"
import style0 from "./ChildAgent.vue?vue&type=style&index=0&id=fdbceace&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbceace",
  null
  
)

export default component.exports